import { ApiTicketService } from "./../../services/api/api-ticket.service";
import { SocketService } from "./../../services/socket/socket.service";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WaitingComponent } from "./waiting.component";
import { RouterModule } from "@angular/router";
import { FuseSharedModule } from "@fuse/shared.module";
import { AuthGuard } from "app/guard/auth.guard";
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { SwiperComponent } from "../swiper/swiper.component";

const routes = [
    {
        path: "waiting/:id",
        component: WaitingComponent,
        canActivate: [AuthGuard],
    },
];

@NgModule({
    declarations: [WaitingComponent, SwiperComponent],
    imports: [RouterModule.forChild(routes), CommonModule, FuseSharedModule],
    exports: [WaitingComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [SocketService, ApiTicketService],
})
export class WaitingModule {}
